import React, { useState } from 'react';
import Banner from '../../components/Banner/Banner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow, faMailBulk, faPhoneSquareAlt, faFax } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // This would normally be an API call to send the form data
    // For now, we'll just simulate a successful submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitMessage({
        type: 'success',
        text: 'Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapılacaktır.'
      });
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      
      // Clear success message after 5 seconds
      setTimeout(() => {
        setSubmitMessage(null);
      }, 5000);
    }, 1500);
  };

  return (
    <>
      <Banner title="İletişim" />
      
      <div className="bizler_section_wrapper">
        <div className="container content-container">
          <div className="contact-content">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="contact-info">
                  <h3 className="section-title">İletişim Bilgileri</h3>
                  <ul className="contact-info-list">
                    <li>
                      <FontAwesomeIcon icon={faLocationArrow} className="icon" />
                      <span>İzmir Teknoloji Geliştirme Bölgesi İYTE Kampüsü, 35430, Urla, İzmir</span>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faMailBulk} className="icon" />
                      <span>info@teknoma.net</span>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faPhoneSquareAlt} className="icon" />
                      <span>+90 (232) 765 90 01</span>
                    </li>
                    <li>
                      <FontAwesomeIcon icon={faFax} className="icon" />
                      <span>+90 (232) 765 90 02</span>
                    </li>
                  </ul>
                </div>
                
                <div className="google-map">
                  <iframe
                    src="https://maps.google.com/maps?q=G%C3%BClbah%C3%A7e%2C%20%C4%B0zmir%20Teknoloji%20Geli%C5%9Ftirme%20B%C3%B6lgesi%20%C4%B0zmir%20Y%C3%BCksek%20Teknoloji%20Enstit%C3%BCs%C3%BC%2C%2035437%20Urla%2F%C4%B0zmir&t=m&z=15&output=embed&iwloc=near"
                    title="Gülbahçe, İzmir Teknoloji Geliştirme Bölgesi İzmir Yüksek Teknoloji Enstitüsü, 35437 Urla/İzmir"
                    aria-label="Gülbahçe, İzmir Teknoloji Geliştirme Bölgesi İzmir Yüksek Teknoloji Enstitüsü, 35437 Urla/İzmir"
                    width="100%"
                    height="300"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
              
              <div className="col-lg-6 col-md-6">
                <div className="contact-form">
                  <h3 className="section-title">Bize Yazın</h3>
                  
                  {submitMessage && (
                    <div className={`alert alert-${submitMessage.type}`}>
                      {submitMessage.text}
                    </div>
                  )}
                  
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="name">Adınız Soyadınız</label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="email">E-posta Adresiniz</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="subject">Konu</label>
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="message">Mesajınız</label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;